import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/navbar.css';

/* === Start "Navbar Component" === */
function Navbar() {
  /* === Start "State Hooks" === */
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [vpsDropdownOpen, setVpsDropdownOpen] = useState(false);
  const [osDropdownOpen, setOsDropdownOpen] = useState(false);
  const [ubuntuOpen, setUbuntuOpen] = useState(false);
  const [debianOpen, setDebianOpen] = useState(false);
  const [almaOpen, setAlmaOpen] = useState(false);
  const [rockyOpen, setRockyOpen] = useState(false);
  const [centosOpen, setCentosOpen] = useState(false);
  /* === End "State Hooks" === */

  /* === Start "Sidebar Toggle Handlers" === */
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
    setVpsDropdownOpen(false);
    setOsDropdownOpen(false);
    setUbuntuOpen(false);
    setDebianOpen(false);
    setAlmaOpen(false);
    setRockyOpen(false);
    setCentosOpen(false);
  };
  /* === End "Sidebar Toggle Handlers" === */

  return (
    <>
      {/* === Start "Top Navbar" === */}
      <nav className="navbar">
        <div className="hamburger" onClick={toggleSidebar}>
          {sidebarOpen ? '✖' : '☰'}
        </div>

        <div className="navbar-center">
          <Link to="/">
            <img src="/logo_iword.png" alt="Iword Hosting Logo" className="navbar-logo" />
          </Link>
        </div>
      </nav>
      {/* === End "Top Navbar" === */}

      {/* === Start "Sidebar Menu" === */}
      {sidebarOpen && (
        <div className="sidebar">
          {/* === Start "Static Links" === */}
          <Link to="/" className="navbar-link" onClick={closeSidebar}>Home</Link>
          <a
            href="https://account.i-word.net/client/login"
            className="navbar-link"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeSidebar}
          >
            Client Login
          </a>
          <a
            href="https://account.i-word.net/plugin/support_manager/knowledgebase"
            className="navbar-link"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeSidebar}
          >
            Knowledgebase
          </a>
          <Link to="/domains" className="navbar-link" onClick={closeSidebar}>Domains</Link>
          <Link to="/cpanel" className="navbar-link" onClick={closeSidebar}>cPanel Shared Hosting</Link>
          <a
            href="https://cpanel.tools"
            className="navbar-link"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeSidebar}
          >
            cPanel Demo
          </a>
          {/* === End "Static Links" === */}

          {/* === Start "VPS + Applications Dropdown" === */}
          <div className="dropdown-header" onClick={() => setVpsDropdownOpen(!vpsDropdownOpen)}>
            VPS + Applications ▾
          </div>
          {vpsDropdownOpen && (
            <div className="dropdown-rows">
              <Link to="/wordpress" className="dropdown-link" onClick={closeSidebar}>WordPress</Link>
              <Link to="/webmin" className="dropdown-link" onClick={closeSidebar}>Webmin</Link>
              <Link to="/prestashop" className="dropdown-link" onClick={closeSidebar}>Prestashop</Link>
              <Link to="/easypanel" className="dropdown-link" onClick={closeSidebar}>EasyPanel</Link>
              <Link to="/cyberpanel" className="dropdown-link" onClick={closeSidebar}>CyberPanel</Link>
              <Link to="/docker" className="dropdown-link" onClick={closeSidebar}>Docker</Link>
            </div>
          )}
          {/* === End "VPS + Applications Dropdown" === */}

          {/* === Start "VPS + Operating System Dropdown" === */}
          <div className="dropdown-header" onClick={() => setOsDropdownOpen(!osDropdownOpen)}>
            VPS + Operating System ▾
          </div>
          {osDropdownOpen && (
            <div className="dropdown-rows">

              {/* === Start "Ubuntu Nested Dropdown" === */}
              <div className="dropdown-header nested" onClick={() => setUbuntuOpen(!ubuntuOpen)}>
                Ubuntu Version ▾
              </div>
              {ubuntuOpen && (
                <div className="dropdown-rows nested-child">
                  <Link to="/ubuntu2204" className="dropdown-link" onClick={closeSidebar}>22.04 x64</Link>
                  <Link to="/ubuntu2404" className="dropdown-link" onClick={closeSidebar}>24.04 x64</Link>
                </div>
              )}
              {/* === End "Ubuntu Nested Dropdown" === */}

              {/* === Start "Debian Nested Dropdown" === */}
              <div className="dropdown-header nested" onClick={() => setDebianOpen(!debianOpen)}>
                Debian Version▾
              </div>
              {debianOpen && (
                <div className="dropdown-rows nested-child">
                  <Link to="/debian11" className="dropdown-link" onClick={closeSidebar}>11 x64</Link>
                  <Link to="/debian12" className="dropdown-link" onClick={closeSidebar}>12 x64</Link>
                </div>
              )}
              {/* === End "Debian Nested Dropdown" === */}

              {/* === Start "AlmaLinux Nested Dropdown" === */}
              <div className="dropdown-header nested" onClick={() => setAlmaOpen(!almaOpen)}>
                AlmaLinux Version▾
              </div>
              {almaOpen && (
                <div className="dropdown-rows nested-child">
                  <Link to="/almalinux8" className="dropdown-link" onClick={closeSidebar}>8 x64</Link>
                  <Link to="/almalinux9" className="dropdown-link" onClick={closeSidebar}>9 x64</Link>
                  <Link to="/almalinux10" className="dropdown-link" onClick={closeSidebar}>10 x64</Link>
                </div>
              )}
              {/* === End "AlmaLinux Nested Dropdown" === */}

              {/* === Start "Rocky Linux Nested Dropdown" === */}
              <div className="dropdown-header nested" onClick={() => setRockyOpen(!rockyOpen)}>
                Rocky Linux Version▾
              </div>
              {rockyOpen && (
                <div className="dropdown-rows nested-child">
                  <Link to="/rockylinux8" className="dropdown-link" onClick={closeSidebar}>8 x64</Link>
                  <Link to="/rockylinux9" className="dropdown-link" onClick={closeSidebar}>9 x64</Link>
                  <Link to="/rockylinux10" className="dropdown-link" onClick={closeSidebar}>10 x64</Link>
                </div>
              )}
              {/* === End "Rocky Linux Nested Dropdown" === */}

              {/* === Start "CentOS Nested Dropdown" === */}
              <div className="dropdown-header nested" onClick={() => setCentosOpen(!centosOpen)}>
                CentOS Version ▾
              </div>
              {centosOpen && (
                <div className="dropdown-rows nested-child">
                  <Link to="/centos9stream" className="dropdown-link" onClick={closeSidebar}>9 Stream x64</Link>
                  <Link to="/centos10stream" className="dropdown-link" onClick={closeSidebar}>10 Stream x64</Link>
                </div>
              )}
              {/* === End "CentOS Nested Dropdown" === */}
            </div>
          )}
          {/* === End "VPS + Operating System Dropdown" === */}

          {/* === Start "Footer Links" === */}
          <Link to="/about" className="navbar-link" onClick={closeSidebar}>About</Link>
          <Link to="/contact" className="navbar-link" onClick={closeSidebar}>Contact</Link>
          <Link to="/trust" className="navbar-link trust-badge" onClick={closeSidebar}>
  Trust Center <span className="badge">🔒</span>
</Link>
<Link to="/support" className="navbar-link trust-badge" onClick={closeSidebar}>
  Support Center <span className="badge">🛠️</span>
</Link>
          <Link to="/sitemap" className="navbar-link" onClick={closeSidebar}>Sitemap</Link>
          {/* === End "Footer Links" === */}
        </div>
      )}
      {/* === End "Sidebar Menu" === */}
    </>
  );
}
/* === End "Navbar Component" === */

export default Navbar;
